import React, { useContext, createContext } from 'react'
import { FormContextType } from './Form.types'

const FormContext = createContext<FormContextType>(undefined as any)

export const FormContextConsumer = FormContext.Consumer
export const FormContextProvider = FormContext.Provider

export const useFormContext = () => {
    const formContext = useContext(FormContext)

    return formContext
}
